import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../ricos-context';
import {
  getIsModalOpen,
  useModalService,
  useModalState,
} from './../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../ricos-types';
import { EditIcon, ToggleButton } from './../../toolbars-ui';
import { FLOATING_PLUGIN_TOOLBAR } from './../../toolbars-v3';

import type { InsertModalProps } from './insert-modal/InsertModal';
import { InsertModal } from './insert-modal/InsertModal';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
  id: string;
};

export const EditHtmlButton: FC<Props> = ({ toolbarItem, dataHook, id }) => {
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));

  const onClick = () => {
    const componentProps: InsertModalProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      closeModal: () => modalService.closeModal(id),
    };

    const isModalOpen = modalService.isModalOpen(id);
    isModalOpen
      ? modalService.closeModal(id)
      : modalService.openModal({
          Component: InsertModal,
          id,
          componentProps,
          layout: isMobile ? 'fullscreen' : 'floating',
          positioning: {
            referenceElement:
              referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ??
              referenceElement,
            placement: 'right-start',
          },
          withTransition: true,
          noPadding: true,
          type: 'exclusive',
          enableDrag: !isMobile,
          dragHandleSelector: '[data-drag-handler]',
        });
  };

  return (
    <ToggleButton
      active={isModalOpen}
      dataHook={dataHook}
      Icon={EditIcon}
      label={t('HtmlPlugin_EditHtml_Tooltip')}
      tooltip={t('HtmlPlugin_EditHtml_Tooltip')}
      onClick={onClick}
      setRef={setReferenceElement}
    />
  );
};
